<template>
   <div style="margin:5px 0;border: 1px solid #ddd;border-bottom:0px;" >
     <div style="background-color: #ececec;line-height:35px;padding-left:5px;">
       {{$lang("关联文件列表")}}：<el-button @click="showDialog" v-if="editMode"><i class="fa fa-paperclip" ></i>{{$lang("添加关联")}}</el-button>
        <el-button @click="deleteFile" v-if="editMode"><i class="el-icon-delete" ></i>{{$lang("删除")}}</el-button>

     </div>
     <div style="width:100%;"  v-show="showTable">
     <mw-table :api="api" :columns="attachColumns" :pagination="false" ref="relFileTable" :defaultParams="defaultParams"
                      :defaultParamsAutoLoad="true" :autoLoad="false"></mw-table>
     </div>

     <mw-dialog ref="relDialog"   size="small_large" :title="$lang('选择关联文件')"  :footerButton="footerButton">


     <div class="rellife">

        <el-form  label-width="7em" ref="formName">

          <el-col :span="24">
            <el-form-item :label="$lang('拟稿时间')" prop="createTime">
                <el-radio-group v-model="form.createTime">
                  <el-radio label="shortcut">{{$lang("快捷时间段")}}</el-radio>
                  <el-radio label="period">{{$lang("时间范围")}}</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="24"  v-show="form.createTime === 'shortcut'">

            <el-form-item>

              <el-radio-group v-model="form.shortcut" @change="handleTime">
                <el-row style="margin-bottom:17px">
                  <el-radio label="day">{{$lang('最近一天')}}</el-radio>
                  <el-radio label="week">{{$lang('最近一周')}}</el-radio>
                  <el-radio label="month">{{$lang('最近一月')}}</el-radio></el-row>
                    <el-row>
                  <el-radio label="halfyear">{{$lang("最近半年")}}</el-radio>
                  <el-radio label="oneyear">{{$lang('最近一年')}}</el-radio>
                 <el-radio label="threeyear">{{$lang('最近三年')}}</el-radio></el-row>
                </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="24"  v-show="form.createTime === 'period'">
            <el-form-item  prop="period">
               <el-col :span="24">
                <template>
                  <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    :placeholder="$lang('选择日期')"
                    :picker-options="pickerBeginDateBefore">
                  </el-date-picker>
                </template>
                {{$lang('至')}}
                <el-date-picker
                    v-model="form.finishDate"
                    type="date"
                    :placeholder="$lang('选择日期')"
                    :picker-options="pickerBeginDateAfter">
                  </el-date-picker>
            </el-col>
            </el-form-item>
          </el-col>

          <el-col  :span="24">
            <el-form-item :label="$lang('搜索范围')" prop="searchRange" >
              <el-radio-group v-model="form.searchRange">
                <el-radio label="system">{{$lang('整个系统')}}</el-radio>
                <el-radio label="dept">{{$lang('整个单位')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col  :span="24">
            <el-form-item :label="$lang('文件类型')" prop="mixId" >
              <el-select v-model="form.mixId" :placeholder="$lang('请选择')">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="15" >
              <el-form-item :label="$lang('关键字')" prop="titleLike" >
                  <el-input  v-model="form.titleLike">
                    <el-button v-waves slot="append" type="primary"  @click="search()">{{$lang('查询')}}</el-button>
                  </el-input>
              </el-form-item>
          </el-col>

        </el-form>


    <mw-table :columns="findColumns" :pagination="false"  :data="tableData" :autoLoad="false"
    ref="findTable" :style="templateStyle" class="tableStyle" :defaultParamsAutoLoad="true"></mw-table>
  </div>
 </mw-dialog>
 </div>

</template>
<script>
  import store from '@/common/vuex/store_rt.js'
  import { mapGetters } from 'vuex'
  export default
  {
    name:'form-rel-file-selection',
    data() {
      let me=this;
      let config=this.$options.config;
      let editMode=!config.getCurrentObject().isTextMode();
      return {
        editMode: editMode,
        api:'business.listRelFile',
        defaultParams:{},
        tableData: [],
        attachColumns: [
          {type: 'selection'},
          {type: 'index'},
          {prop: 'moduleName', label: $lang('所属模块名'),width:'180'},
          {prop: 'fldtm', label: $lang('题名'),formatter:me.defaultTitleFormatter}
        ],
        findColumns: [
          {type: 'selection'},
          {type: 'index'},
          {prop: 'fldtm', label: $lang('题名'),formatter:me.defaultTitleFormatter},
          {prop: 'createTime', label: $lang('拟稿时间'),width:'180'},
          {prop: 'fldbh', label: $lang('文号'),width: '120'},
          {prop: 'initusername', label: $lang('拟稿人'),width: '120'}
        ],
        templateStyle: {
          height: 'auto',
         },
         // 折叠表格面板
        showTable:true,
        startDate :'',
        finishDate: '',

        form:{
          createTime: 'period',
          searchRange: 'dept'
        },
        options: [],
        rules: {},
        footerButton: [
          {label:$lang('取消'), func: this.selectCancel, type: 'default'},
          {label:$lang('确定'), func: this.selectSure}
        ],
        pickerBeginDateBefore:{
        disabledDate(time) {

          if(me.form.finishDate != ''){
            return time.getTime() > me.form.finishDate
          }

        }
      },

      pickerBeginDateAfter:{
        disabledDate(time) {
          return time.getTime() < me.form.startDate
        }
      },
      }
    },

    store,

    mounted() {
      let me = this;
      this.defaultParams ={moduleId: this.$options.params.moduleId,
        docId:this.$options.params.businessId ?this.$options.params.businessId :''}
    },
    computed: {
      ...mapGetters([
        'expUser'
      ])
    },

    methods: {
      selectSure(){
        let me=this;
        if(this.mwRef('findTable').getMultipleSelection().length > 0){
            this.selectCancel();
            this.mwRef('findTable').getMultipleSelection().forEach(item => {
              let params ={
                docId: this.$options.params.tempBusinessId ? this.$options.params.tempBusinessId:this.$options.params.businessId,
                docName:this.$options.params.fldtm,
                moduleId:this.$options.params.moduleId,
                relModuleId:item.moduleId,
                relDocId:item.id,
                relDocName:item.fldtm};
              this.mwApi.business.saveRelLife(params).then(res =>{
                if(res.success){
                  if(res.result === '已存在'){
                    this.mwMsg($lang('该关联文件已存在'))
                  }else{
                  this.mwRef('relFileTable').refresh();
                  }}
              })

            });
        }else{
          this.mwMsg('info',$lang('请选择你要关联的文件'));
        }
      },

      selectCancel(){
        this.mwRef('relDialog').hide();
        this.mwRef('formName').resetFields();
      },

      search(){

        if(this.form.titleLike){
          if(!this.form.mixId){
            this.mwMsg('info',$lang('请选择文件类型'));
          }else{
            let p = {start: 0, limit: 1000,mixId: this.form.mixId,filter:{fldtm:this.form.titleLike}};
            if(this.form.searchRange === 'dept'){
               if(this.expUser.dep.loginUnit){
                p.unitFilter = this.expUser.dep.loginUnit.id;
               }else{
                p.unitFilter = this.expUser.dep.loginRootDept.id;
              }
            }
            let startDate,finishDate;
            if(this.form.createTime != 'shortcut'){
              if(this.form.startDate){
                startDate =this.format(this.form.startDate,"yyyy-MM-dd HH:mm:ss");
              }
              if(this.form.finishDate){
                let mat={};
                mat.M=this.form.finishDate.getMonth()+1;//月份记得加1
                mat.M =this.check(mat.M);
                mat.Y=this.form.finishDate.getFullYear();
                mat.D = this.form.finishDate.getDate();
                mat.D=this.check(mat.D);
                finishDate =mat.Y+"-"+mat.M+"-"+mat.D+' '+'24:00:00';
              }
            }
            else {
              if(this.startDate){
                startDate = this.format(this.startDate,"yyyy-MM-dd HH:mm:ss");
                finishDate = this.format(this.finishDate,"yyyy-MM-dd HH:mm:ss");
              }
            }
            if(startDate && finishDate){
                p.customCondition = "createTime >= {ts '"+startDate +"'} and createTime <= {ts '"+ finishDate +"'} "
            }
            else if(!startDate && finishDate){
              p.customCondition = "createTime <= {ts '"+ finishDate +"'} "
            }else if(!finishDate && startDate){
              p.customCondition = "createTime >= {ts '"+startDate +"'} "
            }
           this.mwApi.data.listDocData(p).then(res =>{
              if(res.success){
                if(res.result.length === 0){
                  this.mwMsg($lang('未查询到数据'));}
                  this.tableData = res.result;
                  this.mwRef('findTable').setData(this.tableData);
                }
              })
            }
            }
            else{
              this.mwMsg('info',$lang('请填写关键字'))
            }
      },
      showDialog(){
        this.mwRef('relDialog').show();
        let config =  this.$options.config.getConfig();
        if(config.moduleName){
          let formName = config.moduleName.split(',');
          let formId =  config.moduleId.split(',');
          this.options = [];
          for(let i = 0;i<formId.length;i++){
            this.options.push({
                value : formId[i],
                label : formName[i]
            });
          }
        }
      },

      deleteFile(){
        if(this.mwRef('relFileTable').getMultipleSelection().length === 0){
          this.mwMsg($lang('请选择你要删除的数据'))
        }else{
           this.$confirm($lang('确定要删除该关联文件?'),$lang('提示'),{
            confirmButtonText: $lang('确定'),
            cancelButtonText: $lang('取消'),
            type: 'warning'
           }).then(() => {

             let ids = [];
             this.mwRef('relFileTable').getMultipleSelection().forEach(item =>{
                ids.push(item._id);
             })
             this.mwApi.business.delRelFile(ids).then(res =>{
                if(res.success){
                  this.mwMsg($lang('删除成功'));
                  this.mwRef('relFileTable').refresh();
                }
             })

           }).catch(()=>{});

        }
      },
     defaultTitleFormatter(data){
      let me=this;
      return (<span class={{'link':true}} title={data.fldtm} onClick={(event)=>me._showForm(data,event)}>
          {data.fldtm?data.fldtm:$lang('无标题')}
        </span>)
     },
      _showForm(row, event) {
      event.stopPropagation();
      let me = this, formId = row["#table"],businessId = row.id;
      me.mwApi.data.getFormData({formId: formId, dataId: businessId}).then((data) => {
        let p={};
        p.businessId=businessId;
        p.moduleId=data.result.moduleId;
        p.appId=data.appId;
        p.editMode=false;
        p.formOpenSource='pc:rel-file-selection';
        PF.show('flowForm',p);
      });
    },

    //   _showForm(row, event) {
    //     event.stopPropagation();
    //     let me =this;
    //     let p={};
    //     p.businessId = row.id;
    //     p.editMode=false;
    //     p.moduleId = row.moduleId;
    //     p.appId = row.initappid;
    //     p.formOpenSource='pc:rel-file-selection';
    //     PF.show('normalForm',p);
    // },

    handleTime(data){
      if(data === 'week'){
         this.getDay(-7);
      }else if(data === 'month'){
        this.getMonthDay(-1);
      }else if(data === 'oneyear'){
        this.getMonthDay(-12);
      }else if(data === 'halfyear'){
        this.getMonthDay(-6);
      }else if(data === 'threeyear'){
        this.getMonthDay(-36);
      }else{
        this.getDay(-1);
      }
    },


    getDay(days){
       let today = new Date(),day= new Date();
       let targetday_milliseconds=today.getTime() + 1000*60*60*24*days;
       day.setTime(targetday_milliseconds); //注意，这行是关键代码
        let mat={};
        mat.M=day.getMonth()+1;//月份记得加1
        mat.Y=day.getFullYear();
        mat.D = day.getDate();
        mat.H = day.getHours();
        mat.mi = day.getMinutes();
        mat.S = day.getSeconds();
        let nowday ={};
        nowday.M=today.getMonth()+1;//月份记得加1
        nowday.Y=today.getFullYear();
        nowday.D = today.getDate();
        nowday.H = today.getHours();
        nowday.mi = today.getMinutes();
        nowday.S = today.getSeconds();
        this.startDate= new Date(mat.Y+"-"+mat.M+"-"+mat.D+' '+mat.H+':'+mat.mi+':'+mat.S);
        this.finishDate = new Date(nowday.Y+"-"+nowday.M+"-"+nowday.D+' '+nowday.H+':'+nowday.mi+':'+nowday.S);
    },

    getMonthDay(mon){
        let nowdate = new Date();
        let today = new Date();
        nowdate.setMonth(nowdate.getMonth()+mon);
        let mat={};
        mat.M=nowdate.getMonth()+1;//月份记得加1
        mat.Y=nowdate.getFullYear();
        mat.D = nowdate.getDate();
        mat.H = nowdate.getHours();
        mat.mi = nowdate.getMinutes();
        mat.S = nowdate.getSeconds();
        let day ={};
        day.M=today.getMonth()+1;//月份记得加1
        day.Y=today.getFullYear();
        day.D = today.getDate();
        day.H = today.getHours();
        day.mi = today.getMinutes();
        day.S = today.getSeconds();
        this.startDate= new Date(mat.Y+"-"+mat.M+"-"+mat.D+' '+mat.H+':'+mat.mi+':'+mat.S);
        this.finishDate = new Date(day.Y+"-"+day.M+"-"+day.D+' '+day.H+':'+day.mi+':'+day.S);
    },

    format(date,str){
      var mat={};
      mat.M=date.getMonth()+1;//月份记得加1
      mat.H=date.getHours();
      mat.s=date.getSeconds();
      mat.m=date.getMinutes();
      mat.Y=date.getFullYear();
      mat.D=date.getDate();
      mat.d=date.getDay();//星期几
      mat.d=this.check(mat.d);
      mat.H=this.check(mat.H);
      mat.M=this.check(mat.M);
      mat.D=this.check(mat.D);
      mat.s=this.check(mat.s);
      mat.m=this.check(mat.m);

      if(str.indexOf(":")>-1){
  　　　　 return mat.Y+"-"+mat.M+"-"+mat.D+" "+mat.H+":"+mat.m+":"+mat.s;
      }
      if(str.indexOf("/")>-1){
          return mat.Y+"-"+mat.M+"-"+mat.D+" "+mat.H+"/"+mat.m+"/"+mat.s;
      }
      if(str.indexOf("-")>-1){
          return mat.Y+"-"+mat.M+"-"+mat.D+" "+mat.H+"-"+mat.m+"-"+mat.s;
      }
   },
    //检查是不是两位数字，不足补全
    check(str){
        str=str.toString();
        if(str.length<2){
            str='0'+ str;
        }
        return str;
      }
    },
  destroyed(){

  }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .tableStyle {
    .mw-table{
      height: auto !important
    }
  }
.rellife{
  .el-form-item {
    margin-bottom: 17.6px;
  }
}

</style>




// WEBPACK FOOTER //
// src/common/components/extend/form/src/components/rel-file-selection.vue